import type { ServerError } from '@apollo/client';

import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	TrackPromotionImpression,
	type TrackPromotionImpressionMutation,
	type TrackPromotionImpressionMutationVariables,
} from './api.graphql';

type EventData = Omit<TrackPromotionImpressionMutationVariables['input'], 'eventType'>;

function getReportParams(error: unknown) {
	/* eslint-disable @typescript-eslint/consistent-type-assertions */
	if (error instanceof Error) {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
		if ((error as any).statusCode) {
			const response = error as ServerError;
			return {
				status: response.statusCode,
				message: response.message,
			};
		}
		return {
			message: error.message,
		};
	}
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	if ((error as any).status) {
		const response = error as Response;
		return {
			status: response.status,
			message: response.statusText,
		};
	}
	return {};
	/* eslint-enable @typescript-eslint/consistent-type-assertions */
}

export async function trackPromotionImpression(
	eventData: EventData,
	{ gql: { fetch }, errorReporter: { report } }: UtilityContext,
): Promise<void> {
	try {
		await fetch<TrackPromotionImpressionMutation, TrackPromotionImpressionMutationVariables>({
			query: TrackPromotionImpression,
			variables: {
				input: {
					eventType: 'IMPRESSION',
					...eventData,
				},
			},
			rejectOnError: false,
		});
	} catch (error) {
		void report({
			error: new Error('Error tracking promotion impression', { cause: error }),
			params: getReportParams(error),
		});
	}
}
